import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Anonymous, device-local client id for the private near-miss log
export function getClientId() {
  let id = localStorage.getItem("coi_client_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `coi_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("coi_client_id", id);
  }
  return id;
}
